import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport, getPayoutHistory } from "../../../redux/actions/reportAction";
import { getPayoutList } from "../../../redux/actions/payoutActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

import { getMerchantDeals } from "../../../redux/actions/voucherActions";
import auth from "../../../services/auth";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class PayableList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'MERCHANT_PAID_PAYOUT',
      path: ["Home", "Payables"],
      links: ["home", "report/payables"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      paymentTermID: '',
      payoutList: '',
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();

    const userinfo = auth.getUserInfo();
    if (userinfo.user_id !== "") {
      this.props.getMerchantDeals(userinfo.user_id);
    }
  }
  componentWillReceiveProps(nextProps) {

    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        let merchant=  nextProps.merchantdealList.merchantInfo? nextProps.merchantdealList.merchantInfo:{} ;
        this.props.getReport({ merchantID: merchant.merchant_id }, 'report/merchant-paid-payout')
      }
    }


    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData });
        this.handleExport(nextProps.reportData);
      }else{
        this.setState({ reportData: [] });
      }
    }

    if (this.props.getpayoutSummary !== nextProps.getpayoutSummary) {
      if (nextProps.getpayoutSummary) {
        isLoading = "false";
        this.setState({ historyPopup: true, payoutHistory: nextProps.getpayoutSummary.data});
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if(this.props.payoutList !== nextProps.payoutList){
      if(nextProps.payoutList){
        isLoading="false";
        this.setState({payoutList: nextProps.payoutList.data})
      }
    }

  }

  handleExport = data => {
    let setDate = (this.state.range == true) ? moment(this.state.startDate).format('MM/DD/YYYY') +' - '+moment(this.state.endDate).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Merchant Name',
        'Offer ID',
        'Offer Name',
        'Payment Term',
        'Refund',
        'Gross Sales',
        'Net Payout',
        'Term Amount',
        'Amount Paid',
      ]
    ];

    {data &&
      data.data.map((data, index) =>
        csvData.push([
          data.merchantName,
          data.OfferID,
          data.OfferName,
          data.paymentTerm,
          data.refundAmount,
          data.grossSales,
          data.netPayout,
          data.termAmount,
          data.amountRemaining,
        ])
      )
    }

    this.setState({ csvData: csvData });
  };

  paymentHistory = (e) => {
    let id = e.target.attributes.getNamedItem("data-key").value;
    let date = e.target.attributes.getNamedItem("data-date").value;
    isLoading = "true";
    this.props.getPayoutHistory({dueDate: date, dealID: id});
  }

  handleClose() {
    this.setState({
      historyPopup: false,
      payoutHistory: '',
    });
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>

        <div className="panel">
          <header className="panel-heading">Payables</header>
          <div className="panel-body">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Merchant Name</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Payment Term</th>
                  <th>Refund</th>
                  <th>Gross Sales</th>
                  <th>Net Payout</th>
                  <th>Term Amount</th>
                  <th>Amount Paid</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
              {!isEmpty(this.state.reportData) ?
                    this.state.reportData.data.map((data, index) =>
                <tr key={data.scheduleID + index}>
                  <td>{data.merchantName}</td>
                  <td>{data.OfferID}</td>
                  <td>{data.OfferName}</td>
                  <td>{data.paymentTerm}</td>
                  <td>{data.refundAmount}</td>
                  <td>{data.grossSales}</td>
                  <td>{data.netPayout}</td>
                  <td>{data.termAmount}</td>
                  <td>{data.amountRemaining}</td>
                  <td><Button bsStyle="success" data-key={data.OfferID} data-date= {data.dueDate} onClick={this.paymentHistory}><i className="glyphicon glyphicon-eye-open"></i> View History</Button></td>
                </tr>
                )
                :
                <tr><td colSpan="13">Data Not Found</td></tr>
              }
              </tbody>
            </table>
          </div>
        </div>
        <Modal show={this.state.historyPopup} onHide={this.handleClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>View History</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Amount</th>
                  <th>Transaction ID</th>
                  <th>Comment</th>
                  <th>Paid Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.payoutHistory ?
                  this.state.payoutHistory.map((history, index) => 
                    <tr>
                      <td>{history.pay_amount}</td>
                      <td>{history.transaction_id}</td>
                      <td>{history.comment}</td>
                      <td>{moment(history.created_on).format('M-D-Y')}</td>
                    </tr>
                  )
                :
                <tr>
                  <td colSpan="2">Data Not Found</td>
                </tr>
                }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    merchantdealList: state.voucherReducer.merchantdealList,
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    getpayoutSummary: state.reportReducer.getpayoutSummary,
    payoutList:  state.payoutReducer.payoutList,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getPayoutHistory,
    getPayoutList,
    getMerchantDeals
  })
)(PayableList);



// WEBPACK FOOTER //
// ./src/app/views/merchant/payable/PayableList.js